import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';

@Component({
  selector: 'app-usuario-generate-pass',
  templateUrl: './usuario-generate-pass.component.html',
  styles: [
  ]
})
export class UsuarioGeneratePassComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      password: ['', [Validators.required]],
      copied: ['', [Validators.required]],
    });
    this.form.patchValue({ password: this.generarPass() });
  }

  guardar(): void {
    this.activeModal.close(this.form.value.password);
  }

  generarPass(): string {
    let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFJHIJKLMNOPQRSTUVWXYZ1234567890';
    let keys = ',.?!+%$#';
    let length = 7;
    let result = '';
    for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    result += keys[Math.floor(Math.random() * keys.length)];
    return result;
  }
}
